import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route changes, EXCEPT when the language is switched (state.keepScroll)
export default function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    if (state && state.keepScroll) return;
    // Only scroll to top when there is no hash — hash links should scroll to their anchor
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, state]);

  return null;
}
